import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdSecurity } from "react-icons/md";
import { CiCalendarDate } from "react-icons/ci";
import { GiAutoRepair } from "react-icons/gi";
import DuesModal from "./DuesModal";

const AddDuesModal = ({
    setIsAddDuesModal,
    addDuesMutate,
    addDuesLoading,
    selectedData,
    landlordData
}) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const selectOptions = [
        { value: "1", label: "Rent" },
        { value: "43", label: "Security" },
        { value: "5", label: "Maintenance" },
    ];

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const renderContent = () => {
        switch (selectedOption) {
            case "43":
            case "1":
            case "5":
                return (
                    <DuesModal
                        setIsAddDuesModal={setIsAddDuesModal}
                        setSelectedOption={setSelectedOption}
                        addDuesMutate={addDuesMutate}
                        addDuesLoading={addDuesLoading}
                        selectedOption={selectedOption}
                        selectedData={selectedData}
                        landlordData={landlordData}
                    />
                );

            default:
                return (
                    <Form>
                        <Wrapper>
                            <DuesGroup>
                                {selectOptions.map((option) => (
                                    <DuesOption
                                        key={option.value}
                                        onClick={() => {
                                            setSelectedOption(option.value);
                                        }}
                                    >
                                        <RadioContainer>
                                            <RadioCircle isSelected={selectedOption === option.value} />
                                            <span className="text-sm">{option.label}</span>
                                        </RadioContainer>
                                    </DuesOption>
                                ))}

                            </DuesGroup>
                        </Wrapper>
                    </Form>
                );
        }
    };

    const renderHeader = () => {
        switch (selectedOption) {
            case "1":
                return (
                    <ProfileSection>
                        <UserImage>
                            <CiCalendarDate size={18} color="#26A69A" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Rent</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "5":
                return (
                    <ProfileSection>
                        <UserImage>
                            <GiAutoRepair size={18} color="#26A69A" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Maintenance</span>
                        </UserInfo>
                    </ProfileSection>
                );
            case "43":
                return (
                    <ProfileSection>
                        <UserImage>
                            <MdSecurity size={18} color="#26A69A" />
                        </UserImage>
                        <UserInfo>
                            <span className="font-medium">Security</span>
                        </UserInfo>
                    </ProfileSection>
                );

            default:
        }
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <Title>{selectedOption ? "Add Dues" : "Select Dues Type"}</Title>
                <CloseButton onClick={() => setIsAddDuesModal(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            {renderHeader()}
            <Content>{renderContent()}</Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Form = tw.form`flex flex-col h-full justify-between`;
const Wrapper = tw.div`grid gap-6 my-6`;
const DuesGroup = tw.div`flex flex-col gap-3 `;
const DuesOption = tw.div`
    flex flex-col gap-2 p-4 border rounded-lg cursor-pointer
    transition-all duration-200 hover:bg-gray-100
`;
const RadioContainer = tw.div`flex items-center gap-3 `;
const RadioCircle = ({ isSelected }) => (
    <div
        className={`w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center ${isSelected ? "border-blue-500" : "border-gray-500"
            }`}
    >
        {isSelected && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
    </div>
);
const UserImage = tw.div`flex w-8 h-8 rounded-full  bg-blue-200 justify-center items-center `;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 p-4`;
const UserInfo = tw.div`flex flex-col`;

export default AddDuesModal;
